<template>
  <div class="page home">
    <section class="hero">
      <div class="hero__inner">
        <div class="hero__left">
          <h1 class="hero__title">
            <span class="hero__brand">{{ $t("hero.brand") }}</span
            ><br />
            {{ $t("hero.titleLine2") }}<br />
            {{ $t("hero.titleLine3") }}
          </h1>
          <p class="hero__desc">
            {{ $t("hero.desc") }}
          </p>
          <div class="hero__cta-group">
            <input
              class="hero__cta-input"
              type="email"
              v-model.trim="email"
              :placeholder="$t('hero.emailPlaceholder')"
            />
            <button
              class="hero__cta-btn"
              @click="sendEmail"
              :disabled="sending"
            >
              {{ sending ? $t("hero.sending") || "Sending…" : $t("hero.cta") }}
            </button>
          </div>
        </div>
        <div class="hero__right">
          <div class="phone-wrap">
            <img class="phone" :src="phoneImg" alt="phone preview" />
          </div>
        </div>
      </div>
    </section>

    <footerBox></footerBox>
  </div>
</template>

<script>
import phoneImg from "@/assets/img/homePage/1.png"
export default {
  components: {},
  data() {
    return {
      phoneImg,
      email: "",
      sending: false,
    }
  },
  methods: {
    async sendEmail() {
      const email = this.email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email)) {
        this.$message && this.$message.error
          ? this.$message.error(
              this.$t
                ? this.$t("hero.invalidEmail") || "Incorrect email format"
                : "Incorrect email format"
            )
          : alert("Incorrect email format")
        return
      }

      try {
        this.sending = true

        // 调用后端 API
        const formData = new FormData()
        formData.append("email", email)

        const response = await fetch(
          "https://pkweb.zandafinancial.com/api/open/test/sendEmail",
          {
            method: "POST",
            body: formData,
          }
        )

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.message || `HTTP ${response.status}`)
        }

        await response.json()

        this.$message && this.$message.success
          ? this.$message.success(
              this.$t
                ? this.$t("hero.sent") || "已成功发送，请查收邮箱"
                : "已成功发送，请查收邮箱"
            )
          : alert("已成功发送，请查收邮箱")
        this.email = ""
      } catch (err) {
        console.error("API send error:", err)
        const errorDetail = err.message || err.toString()
        const msgBase = this.$t
          ? this.$t("hero.sendFailed") || "发送失败，请稍后重试"
          : "发送失败，请稍后重试"
        const finalMsg = errorDetail ? `${msgBase} (${errorDetail})` : msgBase
        this.$message && this.$message.error
          ? this.$message.error(finalMsg)
          : alert(finalMsg)
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;

  background: linear-gradient(
        180deg,
        rgba(4, 7, 234, 0.55) 0%,
        rgba(7, 79, 195, 0.42) 70%,
        rgba(255, 255, 255, 0) 100%
      )
      no-repeat,
    #ffffff;
  background-size: 100% 420px;
  background-position: top left, top left;
}

.hero__inner {
  max-width: 1260px;
  margin: 0 auto;
  padding: 92px 24px 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.hero__left {
  flex: 1 1 46%;
}
.hero__right {
  flex: 1 1 54%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero__title {
  font-size: 40px;
  line-height: 1.2;
  color: #0f172a;
  font-weight: bold;
  letter-spacing: -0.01em;
  margin-bottom: 18px;
  opacity: 0;
  transform: translateY(12px);
  animation: fadeInUp 0.6s ease forwards;
}
.hero__brand {
  color: #0f172a;
}

.hero__desc {
  font-size: 18px;
  line-height: 1.9;
  color: #475569;
  max-width: 620px;
  margin-bottom: 32px;
  opacity: 0;
  transform: translateY(12px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.08s;
}

.hero__cta-group {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 9999px;
  padding: 4px;
  width: 380px;
  max-width: 100%;
  box-shadow: 0 6px 16px rgba(30, 58, 138, 0.08);
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
  opacity: 0;
  transform: translateY(12px);
  animation: fadeInUp 0.6s ease forwards;
  animation-delay: 0.16s;
}
.hero__cta-group:focus-within {
  border-color: rgba(37, 99, 235, 0.45);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.18),
    0 0 0 3px rgba(37, 99, 235, 0.12) inset;
}
.hero__cta-input {
  flex: 1;
  height: 36px;
  border: none;
  outline: none;
  padding: 0 12px 0 14px;
  font-size: 13px;
  color: #0f172a;
  background: transparent;
  caret-color: #2563eb;
}
.hero__cta-input::placeholder {
  color: #94a3b8;
}
.hero__cta-btn {
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 9999px;
  background: #2563eb;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.hero__cta-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.28);
  background: #1d4ed8;
}
.hero__cta-btn::after {
  content: "";
  position: absolute;
  inset: -60% -20%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.45) 45%,
    rgba(255, 255, 255, 0) 85%
  );
  transform: translateX(-120%);
  transition: transform 0.6s ease;
}
.hero__cta-btn:hover::after {
  transform: translateX(120%);
}

.phone-wrap {
  position: relative;
  width: 560px;
  max-width: none;
  margin-right: -120px;
  filter: drop-shadow(0 24px 48px rgba(30, 58, 138, 0.25));
  z-index: 1;
  animation: floatY 4.5s ease-in-out infinite; /* 原为 6s */
}
.phone {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 28px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes floatY {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-32px);
  }
}

@media (max-width: 1200px) {
  .hero__title {
    font-size: 36px;
  }
  .phone-wrap {
    width: 620px;
    margin-right: -80px;
  }
}

@media (max-width: 992px) {
  .hero__inner {
    padding: 72px 20px 56px;
    flex-direction: column;
    gap: 32px;
  }
  .hero__title {
    font-size: 32px;
    line-height: 1.25;
    margin-bottom: 20px;
  }
  .hero__desc {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 28px;
  }
  .hero__cta-group {
    width: 100%;
    max-width: 400px;
  }
  .hero__cta-input {
    font-size: 15px;
    height: 44px;
  }
  .hero__cta-btn {
    font-size: 15px;
    height: 44px;
    padding: 0 24px;
  }
  .phone-wrap {
    margin-right: 0;
    width: 420px;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .hero__inner {
    padding: 64px 16px 48px;
    gap: 28px;
  }
  .hero__title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 18px;
  }
  .hero__desc {
    font-size: 14px;
    line-height: 1.65;
    margin-bottom: 26px;
  }
  .hero__cta-group {
    max-width: 360px;
  }
  .hero__cta-input {
    font-size: 14px;
    height: 42px;
  }
  .hero__cta-btn {
    font-size: 14px;
    height: 42px;
    padding: 0 22px;
  }
  .phone-wrap {
    width: 360px;
  }
}

@media (max-width: 576px) {
  .hero__inner {
    padding: 56px 16px 40px;
    gap: 24px;
  }
  .hero__title {
    font-size: 26px;
    line-height: 1.35;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
  }
  .hero__desc {
    font-size: 13px;
    line-height: 1.7;
    margin-bottom: 24px;
  }
  .hero__cta-group {
    max-width: 100%;
    padding: 3px;
  }
  .hero__cta-input {
    height: 40px;
    font-size: 13px;
    padding: 0 12px 0 16px;
  }
  .hero__cta-btn {
    height: 40px;
    font-size: 13px;
    padding: 0 20px;
  }
  .phone-wrap {
    width: 300px;
  }
}

@media (max-width: 480px) {
  .hero__inner {
    padding: 48px 12px 36px;
    gap: 20px;
  }
  .hero__title {
    font-size: 24px;
    line-height: 1.4;
    margin-bottom: 14px;
    letter-spacing: -0.025em;
  }
  .hero__desc {
    font-size: 12px;
    line-height: 1.65;
    margin-bottom: 20px;
  }
  .hero__cta-group {
    padding: 2px;
  }
  .hero__cta-input {
    height: 38px;
    font-size: 12px;
    padding: 0 10px 0 14px;
  }
  .hero__cta-btn {
    height: 38px;
    font-size: 12px;
    padding: 0 18px;
  }
  .phone-wrap {
    width: 260px;
  }
}

@media (max-width: 400px) {
  .hero__inner {
    padding: 44px 10px 32px;
    gap: 18px;
  }
  .hero__title {
    font-size: 22px;
    line-height: 1.4;
    margin-bottom: 12px;
  }
  .hero__desc {
    font-size: 11px;
    line-height: 1.6;
    margin-bottom: 18px;
  }
  .hero__cta-group {
    padding: 2px;
  }
  .hero__cta-input {
    height: 36px;
    font-size: 11px;
    padding: 0 8px 0 12px;
  }
  .hero__cta-btn {
    height: 36px;
    font-size: 11px;
    padding: 0 16px;
  }
  .phone-wrap {
    width: 220px;
  }
}

@media (max-width: 360px) {
  .hero__inner {
    padding: 40px 8px 28px;
    gap: 16px;
  }
  .hero__title {
    font-size: 20px;
    line-height: 1.45;
    margin-bottom: 10px;
  }
  .hero__desc {
    font-size: 10px;
    line-height: 1.55;
    margin-bottom: 16px;
  }
  .hero__cta-group {
    padding: 1px;
  }
  .hero__cta-input {
    height: 34px;
    font-size: 10px;
    padding: 0 6px 0 10px;
  }
  .hero__cta-btn {
    height: 34px;
    font-size: 10px;
    padding: 0 14px;
  }
  .phone-wrap {
    width: 180px;
  }
}

/* 横屏模式优化 */
@media (max-width: 768px) and (orientation: landscape) {
  .hero__inner {
    padding: 40px 16px 32px;
    gap: 20px;
  }
  .hero__title {
    font-size: 24px;
    margin-bottom: 12px;
  }
  .hero__desc {
    font-size: 12px;
    margin-bottom: 16px;
  }
  .hero__cta-group {
    max-width: 300px;
  }
  .phone-wrap {
    width: 200px;
  }
}

/* 高分辨率屏幕优化 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .hero__title {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

@media (prefers-reduced-motion: reduce) {
  .phone-wrap,
  .hero__title,
  .hero__desc,
  .hero__cta-group,
  .hero__cta-btn {
    animation: none !important;
    transition: none !important;
  }
}
</style>
